import { render } from "./DEPRECATED_ Finance_Transaction_Dialog.vue?vue&type=template&id=bb283ef0&scoped=true"
import script from "./DEPRECATED_ Finance_Transaction_Dialog.vue?vue&type=script&lang=js"
export * from "./DEPRECATED_ Finance_Transaction_Dialog.vue?vue&type=script&lang=js"

import "./DEPRECATED_ Finance_Transaction_Dialog.vue?vue&type=style&index=0&id=bb283ef0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb283ef0"]])

export default __exports__